import post from "./post";

const sendReviewReply = async (businessUid, reviewUid, text, source) => {
  return post(`/business/${businessUid}/reviews/${reviewUid}/sendReply`, {
    text,
    source,
  });
};

export default sendReviewReply;
